export default __webpack_public_path__ + "static/media/ngakim.6c5da733.png";